<!--
  @Description: 搜索实体组件
  @Author: wang.y 
  @Date: 2022-03-08 
-->
<template>
  <div class="sea-comp">
    <Input prefix="ios-search" v-model="search_key" @on-change="handleChangeSearch" @on-focus="search_list_show = true" @on-blur="handleFocusSearch" placeholder="添加您关注的公司或机构" />
    <div class="search-list" v-if="search_key && search_list_show">
      <div class="nothing" v-if="search_list.length == 0 && !search_loading">没有找到相关的内容</div>
      <Spin class="search-loading" v-if="search_loading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
      <template v-if="search_list.length > 0 && !search_loading">
        <entity-temp v-for="item,index in search_list" :key="index" :item="item" :entitytype="item.type"></entity-temp>
      </template>
    </div>
  </div>
</template>
<script>
import { searchForEntity } from '@/service'
import EntityTemp from './EntityTemp'
export default {
  components: {
    EntityTemp
  },
  created() { },
  mounted() { },
  data() {
    return {
      search_key: "",
      search_loading: true,
      search_list: [],
      search_list_show: false,
    }
  },
  computed: {},
  methods: {
    async handleChangeSearch() {
      this.search_loading = true;
      let res = await searchForEntity({
        user_key: this.$store.state.user_key,
        keyword: this.search_key
      }, error => {
        this.$Message.error("请求错误！");
      });
      if (res.status == "success") {
        this.$set(this.$data, "search_list", res.res);
        this.search_loading = false;
      } else {
        this.$Message.error(res.message);
      }
    },
    handleFocusSearch() {
      setTimeout(() => {
        this.search_list_show = false;
      }, 200);
    },
  }
}
</script>
<style lang="stylus" scoped>
.sea-comp
  position relative
  >>> .ivu-input-wrapper
    .ivu-input
      height 24px
      width 200px
      border 0
      background none
      border-radius 0
      border-bottom 1px solid #ff8824
      box-shadow none
      outline none
      color #333
      &::-webkit-input-placeholder
        color: #999
    .ivu-input-prefix
      i
        line-height 24px
        color #ff8824
  .search-list
    position absolute
    width 200px
    max-height 200px
    overflow auto
    background #fff
    padding 6px 0
    margin-top 6px
    z-index 10
    right 0
    box-shadow 2px 2px 4px rgba(0, 0, 0, 0.1)
    .search-loading
      color #ff8824
    .nothing
      text-align center
      color #999
      font-size 12px
    >>> .entity-temp
      border 0
      &+ div
        margin-top 10px
</style>